import "./App.css";

import { Route, Routes } from "react-router-dom";
import CheckOutPage from "./pages/CheckOutPage/CheckOutPage";
import Success from "./pages/Success/Success";
import Failure from "./pages/Failure/Failure";
import NotFound from "./pages/NotFound/NotFound";
import ErrorPage from "./pages/ErrorPage/ErrorPage";

function App() {
  return (
    <>
      <Routes>
        <Route path="/checkout/:id" exact="true" element={<CheckOutPage />} />
        {/* <Route path="/:id" exact="true" element={<CheckOutPage />} /> */}
        <Route path="/success" exact="false" element={<Success />} />
        <Route path="/failure" exact="false" element={<Failure />} />
        <Route path="/error" exact="false" element={<ErrorPage />} />
        <Route path="*" exact="false" element={<NotFound />} />
      </Routes>
    </>
  );
}

export default App;
